import React, { useEffect } from "react";
import Popover from "@material-ui/core/Popover";
import styled from "styled-components";
import * as Icon from "./Map/smartiscity/Icons";
import { Avatar } from "antd";
import "./BasicPopover.css";
import { useAuth } from "../hooks/UserAuthProvider";
import UserAvatar from "./UserAvatar";

export default function BasicPopover({
  buttonTitle,
  children,
  showPopover = null,
  setShowPopover = null,
  icon = false,
  isPageProfile = false,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { userData } = useAuth();

  useEffect(() => {
    if (showPopover !== null) {
      const element = document.getElementById(`${buttonTitle}_popover_id`);
      setAnchorEl(showPopover ? element : null);
    }
  }, [showPopover]);

  const handleClick = (event) => {
    const element = document.getElementById(`${buttonTitle}_popover_id`);
    if (setShowPopover !== null) {
      setShowPopover(true);
    }
    setAnchorEl(element);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `${buttonTitle}_popover` : undefined;

  return (
    <div>
      <DropdownContent onClick={() => handleClick()}>
        <DropDownButton $hasIcon={icon} id={`${buttonTitle}_popover_id`}>
          {icon && (
            <UserAvatar
              size={40}
              name={userData?.name}
              surname={userData?.surname}
              isVisibleInSmall={isPageProfile}
            />
          )}
          {!icon && (
            <>
              {buttonTitle}
              <DropdownCaret
                src={Icon.rightArrowBlack}
                width="8px"
                alt="caret icon"
              />
            </>
          )}
        </DropDownButton>
      </DropdownContent>
      <PopoverWrapper
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {children}
      </PopoverWrapper>
    </div>
  );
}

const DropDownButton = styled.button`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  width: ${(props) => (props.$hasIcon ? "fit-content" : "140px")} !important;
  height: 36px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
  transition: all 1s ease;
  border-radius: 2px;
  padding: 0;
  margin: 0;
  &:hover {
    background-color: ${(props) =>
      props.$hasIcon ? "unset" : "rgba(0, 0, 0, 0.2)"};
    transition: all 0.5s ease;
  }
`;

const DropdownCaret = styled.img`
  transform: rotate(90deg);
`;

const DropdownContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
`;

const PopoverWrapper = styled(Popover)`
  .MuiPopover-paper {
    margin-top: 10px;
    margin-left: -30px;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.3);
  }
`;
